import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS_PUBLIC from '../projects/REQUIRED_FIELDS_PUBLIC';

export default function useActiveQuestionsForUser(user, options = {}) {
  return useConnect('project.find', {
    where: {
      eager: {
        $where: {
          questions: {
            $where: {
              userId: user.id,
              response: 'Connect'
            }
          },
          $and: REQUIRED_FIELDS_PUBLIC.$and,
        }
      }
    },
    pagination: {
      page: options.page || 1,
      pageSize: options.pageSize || 3,
      order: 'createdAt desc'
    }
  });
}
